import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "../src/css/alerts.css";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";

import FormSolicitudes from "views/Crea/CrearSolicitud";
import ConsultaSolicitud from "views/Crea/ConsultaSolicitud";
import Autenticacion from "views/examples/Autenticacion";
import Pruebas from "views/examples/PruebaHtmlPdf";
import CreaCasosJuridica from "views/Crea/CreaCasoJuridica";
import ModalSolicitudes from "views/examples/MenuSolicitud";
import SoliictudesJuridica from "views/Crea/SolicitudesJuridica";
import ConsultarGlpi from "views/GLPI/ConsultarGlpi";
import EvidenciaJuridica from "views/Crea/EvidenciaJuridica";
import Tables from "views/Crea/ConsultaSolicitud";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/admin/*" element={<AdminLayout />} />
      <Route path="/auth/*" element={<AuthLayout />} />

      <Route path="*" element={<Navigate to="/auth/login" replace />} />
      <Route path="/admin/CrearSolicitud" element={<FormSolicitudes />} />
      <Route
        path="/admin/ConsultaSolicitud/:id"
        element={<ConsultaSolicitud />}
      />
      <Route path="/Autenticacion" element={<Autenticacion />} />
      <Route path="/pruebas" element={<Pruebas />} />
      <Route path="/CreaCasosJuridica" element={<CreaCasosJuridica />} />
      <Route path="/SoliictudesJuridica" element={<SoliictudesJuridica />} />

      <Route path="/Modal" element={<ModalSolicitudes />} />
      <Route path="/EvidenciaJuridica/:id" element={<EvidenciaJuridica />} />
    </Routes>
  </BrowserRouter>
);
